import { useState } from 'react'

const useRecaptcha = () => {
  const [recaptchaCode, setRecaptchaCode] = useState('')
  const [isRecaptchaValid, setIsRecaptchaValid] = useState(false)

  const handleChangeRecaptcha = (value) => {
    setRecaptchaCode(value)
    if (value) {
      setIsRecaptchaValid(true)
    }
  }

  const handleExpired = () => {
    setIsRecaptchaValid(false)
  }

  return {
    recaptchaCode,
    isRecaptchaValid,
    handleChangeRecaptcha,
    handleExpired
  }
}

export default useRecaptcha
